module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "dedication",
    attrs: {
      "id": "ded"
    }
  }, [_c('p', {
    staticClass: "center"
  }, [_vm._v("IN MEMORIAM: "), _c('em', [_vm._v("Ned Ludd")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("…a lunatic living about 1779, who in a fit of rage smashed up two frames belonging to a Leicestershire “stockinger.”")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—"), _c('em', [_vm._v("The Oxford Universal Dictionary")]), _c('br'), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("Down with all kings but King Ludd.")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—Byron")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ed522a9a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9780795317361_epub_ded_r1.vue
// module id = 69
// module chunks = 0